import {
  isNeverHideableKey,
  type MemberControls,
  EVENT_TYPE_TO_PAGE_KEY,
  pageKeyForEventType,
} from '../types/memberControls'
import { isPageHiddenForMe } from '../services/pageVisibilityService'

export { EVENT_TYPE_TO_PAGE_KEY, pageKeyForEventType }

export interface PageNotificationLike {
  eventType?: string | null
  category?: string | null
  workspaceId?: string | null
}

export interface PageNotificationContext {
  hiddenPages?: ReadonlySet<string> | string[]
  isOwner?: boolean
  role?: string | null
  controls?: MemberControls | null
}

/**
 * Evaluates whether an in-app notification should be hidden from the inbox because
 * the page it references has been hidden by team admin controls.
 */
export function hidePageNotification(
  n: PageNotificationLike,
  ctx?: PageNotificationContext,
): boolean {
  if (!n.eventType) return false

  const pageKey = pageKeyForEventType(n.eventType)
  if (!pageKey || isNeverHideableKey(pageKey)) return false

  if (ctx?.isOwner === true || ctx?.role === 'OWNER') {
    return false
  }

  if (ctx?.hiddenPages) {
    return ctx.hiddenPages instanceof Set
      ? ctx.hiddenPages.has(pageKey)
      : (ctx.hiddenPages as string[]).includes(pageKey)
  }

  if (ctx?.controls) {
    return Array.isArray(ctx.controls.tiles) && ctx.controls.tiles.includes(pageKey)
  }

  return isPageHiddenForMe(pageKey, ctx)
}
